export default __webpack_public_path__ + "static/media/influbitlogofullwithbg.4fd69b52.png";